/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Tools } from '@/@corefabriccanvas';
import { User } from '@/database/userDatabaseService';
import { RedoIcon, UndoIcon } from '@/icons';

interface EraserSubToolProps {
  user: User;
  thickness: number;
  previousTool: Tools;
  setTool: (tool: Tools) => void;
  canvas: any;
  dispatch: (action: any) => void; // Replace `any` with the specific Redux action type if available
  setThickness: (thickness: number, userId: string) => void;
  subToolPosition: string; // Expected position values (e.g., "left", "right")
}

const EraserSubTool: React.FC<EraserSubToolProps> = ({
  user,
  thickness,
  previousTool,
  setTool,
  canvas,
  setThickness,
  subToolPosition,
}) => {
  const [eraserThickness, setLocalEraserThickness] =
    useState<number>(thickness);

  const incrementThickness = () => {
    if (eraserThickness < 21) {
      const newThickness = eraserThickness + 2;
      setLocalEraserThickness(newThickness);
      setThickness(newThickness, user.id);
    }
  };

  const decrementThickness = () => {
    if (eraserThickness > 1) {
      const newThickness = eraserThickness - 2;
      setLocalEraserThickness(newThickness);
      setThickness(newThickness, user.id);
    }
  };

  return (
    <div
      className={`sub-tools ${subToolPosition}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="eraser-buttons">
        <button
          className="subtool-icon-button"
          onClick={() => {
            canvas.undo();
            if (previousTool !== Tools.Eraser) {
              setTool(previousTool);
            }
          }}
        >
          <UndoIcon className={undefined} />
        </button>
        <button
          className="subtool-icon-button"
          onClick={() => {
            canvas.redo();
            if (previousTool !== Tools.Eraser) {
              setTool(previousTool);
            }
          }}
        >
          <RedoIcon className={undefined} />
        </button>
      </div>

      <div className="thickness-div margin-top-20">
        <h4>Boyut: </h4>
        <div className="number-display">
          <button onClick={decrementThickness}>-</button>
          <span className="thickness-value">{eraserThickness}</span>
          <button onClick={incrementThickness}>+</button>
        </div>
      </div>
    </div>
  );
};

export default EraserSubTool;
